const debounce = require('lodash/debounce');

const scrollAnimationsClass = 'scroll-animations';
const scrollAnimationsActiveClass = `${scrollAnimationsClass}--active`;
const bodySelector = document.body;
let active = false;

function sendHeaderEvent() {
  const event = new CustomEvent('header:calculateCustomProperties', {
    detail: {
      origin: scrollAnimationsClass,
      data: { active },
    },
  });
  document.dispatchEvent(event);
}

function handleScroll() {
  const { maxScrollToActive = 50 } = window.scrollAnimationsOptions;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop > maxScrollToActive) {
    if (active) return;
    bodySelector.classList.add(scrollAnimationsActiveClass);
    active = true;
    sendHeaderEvent();
  } else if (active) {
    bodySelector.classList.remove(scrollAnimationsActiveClass);
    active = false;
    sendHeaderEvent();
  }
}

bodySelector.classList.add(scrollAnimationsClass);
document.addEventListener('scroll', debounce(handleScroll, 100), {
  passive: true,
});
